<template>
  <div id="data-view">
    <div class="layout">
      <div class="header">
        <top-header />
      </div>

      <div class="content">

        <!-- 左侧部分 -->
        <div class="left">
          <div class="left-box-item">

            <div class="left-item1">
              <!-- <div style="width: 100%; height: 100%;"><month-ach /></div> -->
              <month-ach ref="monthach" />

            </div>

            <div class="left-item2">
              <!-- <div style="width: 100%; height: 100%;"><pay-way ref="payway" /></div> -->
              <pay-way ref="payway" :payWayData="payWayData"/>
            </div>

            <div class="left-item3">
              <!-- <div style="width: 100%; height: 100%;"><today-sale ref="todaysale" /></div> -->
              <today-sale ref="channelsale" />
            </div>

          </div>
        </div>

        <!-- 中间部分 -->
        <div class="center">

          <div class="center-item">

            <div class="center-item1">
              <amt-chart :amt="SaleAmount"/>
            </div>

            <div class="center-item2">
              <div class="card-list">
                <div class="amt-card-double">
                  <div class="card-left">
                    <div class="lf-icon-1"></div>
                  </div>

                  <div class="card-right">
                    <div class="card-right-top">
                      <div class="card-right-title">
                        会员
                      </div>
                      <div class="card-right-amt">
                        ￥{{ saleData.MemConsumAmt }}
                      </div>
                    </div>
                    <div class="card-right-center">
                    </div>
                    <div class="card-right-bottom">
                      <div class="card-right-title">
                        非会员
                      </div>
                      <div class="card-right-amt">
                        ￥{{ saleData.NonMemConsumAmt }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="amt-card-double">
                  <div class="card-left">
                    <div class="lf-icon-2"></div>
                  </div>
                  <div class="card-right">
                    <div class="card-right-top">
                      <div class="card-right-title">
                        促销
                      </div>
                      <div class="card-right-amt">
                        ￥{{ saleData.PromoteSalesAmt }}
                      </div>
                    </div>
                    <div class="card-right-center">
                    </div>
                    <div class="card-right-bottom">
                      <div class="card-right-title">
                        非促销
                      </div>
                      <div class="card-right-amt">
                        ￥{{ saleData.NonPromoteSalesAmt }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="amt-card-single">
                  <div class="card-left">
                    <div class="lf-icon-3"></div>
                  </div>
                  <div class="card-single-right">
                    <div class="card-right-title">
                      客单价
                    </div>
                    <div class="card-right-amt">
                      ￥{{ saleData.AOV }}
                    </div>
                  </div>
                </div>

                <div class="amt-card-single">
                  <div class="card-left">
                    <div class="lf-icon-4"></div>
                  </div>
                  <div class="card-single-right">
                    <div class="card-right-title">
                      客退率
                    </div>
                    <div class="card-right-amt">
                      {{ saleData.CustRetRate}}%
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="center-item3">
              <times-chart ref="timeschart" />
            </div>

          </div>

        </div>

        <!-- 右侧部分 -->
        <div class="right">
          <div class="right-item">
            <div class="right-item1">
              <cards-item ref="cardsitem" />

            </div>

            <div class="right-item2">
              <scroll-board :data="itemTopData"/>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import topHeader from '../topHeader';
import monthAch from './monthAch';
import scrollBoard from './scrollBoard';
import cardsItem from './cardsItem';
import amtChart from './amtChart';
import timesChart from './timesChart';
import payWay from './payWay';
import todaySale from './todaySale';

import { getsalesummay,gettopsaleitem,gettopsalecategory,
  getsalechanneldistribution,getpaymentsummary,gettimeintervalsale } from '@/api/salesummary.js';

export default {
  name: 'DataView',
  components: {
    topHeader,
    monthAch,
    scrollBoard,
    cardsItem,
    amtChart,
    timesChart,
    payWay,
    todaySale
  },
  data() {
    return {
      saleData: {},
      itemTopData:[],
      clsTopData:[],
      payWayData:[],
      SaleAmount:''
    };
  },
  mounted() {
    // 监听不同浏览器的全屏状态变化事件

    window.addEventListener('resize', this.handleFullscreenChange);

    this.getSaleData();
  },
  beforeDestroy() {
    // 移除事件监听器，防止内存泄漏

    window.removeEventListener('resize', this.handleFullscreenChange);

  },
  methods: {
    handleFullscreenChange() {

      // 获取容器元素
      this.$refs.payway.chart.resize();
      this.$refs.channelsale.chart.resize();
      this.$refs.timeschart.chart.resize();
      this.$refs.cardsitem.chart.resize();
      this.$refs.monthach.chart.resize();
      this.$refs.monthach.chart2.resize();

    },

    getSaleData() {
      //获取当前日期
      //let date = new Date().toISOString().split('T')[0];

      let param = {
        OperDateStart: "2025-01-09",
        OperDateEnd: "2025-01-09",
      };
      getsalesummay(param).then(res => {
        let { Code, Data } = res;
        if (Code == 0) {
          this.saleData = Data;
          if(this.saleData.SaleAmount){
            this.SaleAmount=this.saleData.SaleAmount.toString();
          }

        }
      })
      gettopsaleitem(param).then(res => {
        let { Code, Data } = res; 
        if (Code == 0) {
          this.itemTopData = Data;
        }
      })
      gettopsalecategory(param).then(res => {
        let { Code, Data } = res;
        if (Code == 0) {
          this.clsTopData = Data;
        }
      })
      getsalechanneldistribution(param).then(res => {
        let { Code, Data } = res;
        if (Code == 0) {
          this.$refs.channelsale.setData(Data);
        } 
      })
      getpaymentsummary(param).then(res => {
        let { Code, Data } = res;
        if (Code == 0) {
          this.payWayData=Data;
        } 
      })
      gettimeintervalsale(param).then(res => {
        let { Code, Data } = res;
        if (Code == 0) {
          this.$refs.timeschart.setData(Data);
        } 
      })
    }
  }
};
</script>

<style lang="less" scoped>
body {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0
}

#data-view {
  // width: 100vw;
  // height: 100vh;
  background-image: url('../img/img_bg.png');

  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
  height: 100%;
  width: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0
}

.layout {
  // background-color: #010A59;
  color: #fff;
  height: 100%;
}

.header {
  width: 100%;
  height: 10.83703vh;
}

.content {
  align-items: center;
  display: flex;
  height: calc(100vh - 10.83703vh);
  padding: 0 1.01041vw 1.01041vw;
}

.left {
  width: 26.04166vw;
  height: 100%;
}

.left-box-item {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.left-item1 {
  height: 26.56292vh;
  width: 100%;
  // flex:1;

  // background-color: yellow;
  margin-bottom: 2.10526vh;

}

.left-item2 {
  height: 27.57292vh;
  width: 100%;
  // flex:1;
  // margin: 2.10526vh 0;
  margin-bottom: 2.10526vh;
  // background-color: green;

}

.left-item3 {
  // height: 26.56292vh;
  width: 100%;
  flex: 1;
  // background-color: red;
}

.center {
  flex: 1;
  height: 100%;
  margin: 0 1.14583vw;
}

.center-item {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.center-item1 {
  height: 14.16667vh;
  width: 100%;
  // background-color: yellow;
}

.center-item2 {
  height: 28.16667vh;
  width: 100%;
  // background-color: green;
  margin: 2.10526vh 0;

}

.card-list {
  display: flex;
  flex-wrap: wrap;
}

.amt-card-double:nth-last-child(2n) {
  margin-right: .52083vw;
}

.amt-card-single:nth-last-child(2n) {
  margin-right: .52083vw;
}

.amt-card-double:nth-last-child(odd) {
  margin-left: .52083vw;
}

.amt-card-single:nth-last-child(odd) {
  margin-left: .52083vw;
}

.amt-card-double {
  align-items: center;
  background: rgba(24, 50, 148, 0.30);
  border: 1px solid;
  border-image: linear-gradient(156deg, rgba(255, 255, 255, 0.30) 8%, rgba(255, 255, 255, 0.00) 91%) 1 1;
  border-radius: 8px;
  height: 14.94736vh;
  // margin-top: 2.10526vh;
  width: calc(50% - .52083vw);
  display: flex;
  flex-direction: row;
  // background-color: yellow;
}

.card-left {
  display: flex;
  align-items: center;
  width: 5.625vw;
  height: 100%;
  //居中
  justify-content: center;
}

.card-right {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  font-size: 1.2vw;
}

.card-single-right {
  display: flex;
  flex-direction: row;
  flex: 1;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  margin: 1vw;
  font-size: 1.2vw;

}

.card-right-top {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 1vw;
}

.card-right-center {
  height: 0.1vw;
  opacity: 0.3;
  margin: 0 1vw;
  /* 修改为中间深两边浅的渐变 */
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.06) 0%, #969595 35%, rgba(255, 255, 255, 0.06) 100%);
}

.card-right-bottom {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 1vw;
}

.lf-icon-1 {
  width: 3.5vw;
  height: 3.5vw;
  border-radius: 1.8vw;
  background-color: #FFA837;
  //image居中
  background-image: url('../img/ic_plus-m.png');
  background-size: 50% 50%;
  background-repeat: no-repeat;
  background-position: center;
}

.lf-icon-2 {
  width: 3.5vw;
  height: 3.5vw;
  border-radius: 1.8vw;
  background-color: #f22e2e;
  background-image: url('../img/ic_discount.png');
  background-size: 50% 50%;
  background-repeat: no-repeat;
  background-position: center;
}

.lf-icon-3 {
  width: 3.5vw;
  height: 3.5vw;
  border-radius: 1.8vw;
  background-color: #14d85d;
  background-image: url('../img/ic_price-list.png');
  background-size: 50% 50%;
  background-repeat: no-repeat;
  background-position: center;
}

.lf-icon-4 {
  width: 3.5vw;
  height: 3.5vw;
  border-radius: 1.8vw;
  background-color: #0088f0;
  background-image: url('../img/ic_return-og.png');
  background-size: 50% 50%;
  background-repeat: no-repeat;
  background-position: center;
}

.amt-card-single {
  align-items: center;
  background: rgba(24, 50, 148, 0.30);
  border: 1px solid;
  border-image: linear-gradient(156deg, rgba(255, 255, 255, 0.30) 8%, rgba(255, 255, 255, 0.00) 91%) 1 1;
  border-radius: 8px;
  width: calc(50% - .52083vw);
  // background-color: green;
  height: 11.11405vh;
  margin-top: 2.10526vh;
  display: flex;
  flex-direction: row;
}

.center-item3 {
  // flex: 1;
  width: 100%;
  height: calc(100% - 46.54386vh);
  // background-color: red;
}

.right {
  width: 26.04166vw;
  height: 100%;
}

.right-item {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.right-item1 {
  height: 38.21052vh;
  width: 100%;
  // background-color: yellow;
  margin-bottom: 2.10526vh;

}

.right-item2 {
  flex: 1;
  width: 100%;
  // background-color: red;

}

.el-row {
  margin-bottom: 0;
}
</style>